import { VSkeletonLoader, VCol } from 'vuetify/lib';
import './styles.css';

export default {
  functional: true,
  render(_, context) {
    const { withoutMedia, loading, isCard, isResources, height } =
      context.props || {};

    if (!loading) {
      return context.children;
    }

    if (isResources) {
      return (
        <div
          class={['d-flex flex-column', isCard && 'card-avatar-skeleton-card']}
          style={{ height }}
        >
          {!withoutMedia && (
            <div class="card-avatar-skeleton-media-wrapper mb-4 mb-md-0">
              <VSkeletonLoader loading={true} type="avatar" height="40" />
            </div>
          )}
          <div class="card-avatar-skeleton-content-wrapper">
            <VSkeletonLoader
              loading={true}
              type="sentences"
              class="mt-4 d-none d-md-block"
            />
            <VSkeletonLoader
              loading={true}
              type="paragraph"
              class="mt-4 d-none d-md-block"
            />
            <VSkeletonLoader
              loading={true}
              type="text"
              class="mt-2 d-none d-sm-block d-md-none"
            />
          </div>
        </div>
      );
    }

    return (
      <div
        class={[
          'd-flex flex-column flex-md-row card-avatar-skeleton-root',
          isCard && 'card-avatar-skeleton-card',
        ]}
      >
        {!withoutMedia && (
          <div class="card-avatar-skeleton-media-wrapper mb-4 mb-md-0">
            <VSkeletonLoader loading={true} type="avatar" height="40" />
          </div>
        )}
        <div class="card-avatar-skeleton-content-wrapper">
          <VSkeletonLoader
            loading={true}
            type="sentences"
            class="d-none d-md-block mb-4"
          />
          <VSkeletonLoader loading={true} type="paragraph" />
        </div>
      </div>
    );
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    isResources: {
      type: Boolean,
      default: false,
    },
    height: {
      type: [Number, String],
      default: 0,
    },
    withoutMedia: {
      type: Boolean,
      default: false,
    },
    isCard: {
      type: Boolean,
      default: false,
    },
  },
};
